module.exports = __webpack_public_path__ + "Flag-706.41d9e319d6a28ae8053a6633c9483a3d.svg";